
import { Component, Prop } from 'vue-property-decorator';
import VueApp from '@/@types/app/VueApp';
import { Company } from '@/models/Company';
import { SubscriptionType } from '@/@types/enums/SubscriptionType';
import adminCompanyService from '@/services/company/AdminCompanyService';

const STATUS_LABELS: Record<SubscriptionType, string> = {
  [SubscriptionType.ACTIVE]: 'Active',
  [SubscriptionType.TRIALING]: 'Trialing',
  [SubscriptionType.PAST_DUE]: 'Past due',
  [SubscriptionType.PAUSED]: 'Paused',
  [SubscriptionType.CANCELED]: 'Canceled',
};

@Component
export default class AdminCompanyBillingSection extends VueApp {
  @Prop({ type: Object, required: true }) company: Company;

  isBilling = false;

  get hasSubscription(): boolean {
    return !!this.company.paddle?.subscriptionId;
  }

  get paymentMethod() {
    return this.company.paddle?.payment ?? null;
  }

  get statusLabel(): string {
    const status = this.company.paddle?.status;
    return status ? STATUS_LABELS[status] ?? status : '—';
  }

  get planLabel(): string {
    return this.company.paddle?.planName || '—';
  }

  get priceLabel(): string {
    const amount = this.company.paddle?.priceUnitAmount;
    if (!amount) return '—';
    const dollars = Number(amount) / 100;
    if (Number.isNaN(dollars)) return '—';
    return `$${dollars.toFixed(2)}`;
  }

  handleBillingStatusChange() {
    adminCompanyService.changeCompanyBilling(this.company, (status: boolean) => {
      this.isBilling = status;
      this.company.isBilling = status;
    });
  }

  created() {
    this.isBilling = this.company.isBilling;
  }
}
